import { BRANDS } from "@/data/site";

export const BrandsStrip = () => {
  const doubled = [...BRANDS, ...BRANDS];
  return (
    <section data-testid="brands-strip" className="ji-container py-16 md:py-20">
      <div className="ji-overline mb-6">All major brands serviced</div>
      <div className="overflow-hidden border-y border-[var(--ji-border)] py-6 bg-[var(--ji-surface-alt)]" style={{ borderRadius: 4 }}>
        <div className="ji-marquee-track">
          {doubled.map((b, i) => (
            <span
              key={i}
              data-testid={`brand-${b.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${i}`}
              style={{ fontFamily: "Cabinet Grotesk" }}
              className="inline-flex items-center gap-4 px-8 text-2xl md:text-3xl font-bold tracking-tight text-[var(--ji-text)]/85 hover:text-[var(--ji-accent)] transition-colors"
            >
              {b}
              <span className="text-[var(--ji-accent)] text-base">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
